import { Component, OnInit } from '@angular/core';
import { BaseClass } from '../../../../shared/base-class';
import { PolicySummaryData } from '../../data/policy-summary.data';

@Component({
  selector: 'app-interests',
  templateUrl: './interests.component.html',
  styleUrls: ['./interests.component.scss']
})
export class InterestsComponent extends BaseClass implements OnInit {
  public isOpen: boolean = true;

  constructor(public policySummaryData: PolicySummaryData) {
    super();
  }

  ngOnInit(): void {
  }

  collapse(): void {
    this.isOpen = !this.isOpen;
  }
}
